class SnowplowEventTracker

  constructor: ->
    @trackedEvents = {}

  register: (eventName, {trigger, send, init}) ->
    throw "name is required when registering an event" unless eventName?
    throw "event '#{eventName}' is already registered" if eventName of @trackedEvents
    throw "send function is required when registering an event" unless send?
    @trackedEvents[eventName] =
      trigger : trigger
      init    : init
      send    : send

  reset: ->
    @trackedEvents = {}

  attach: (root) ->
    $.each @trackedEvents, (eventName, event) ->
      if event.trigger?
        $(root).find("[data-track='#{eventName}']").each ->
          el = $(@)
          event.init(eventName, el) if event.init?
          if event.trigger == 'load'
            event.send(eventName, el)
          else
            el.on "#{event.trigger}.tracking", (e, options) ->
              return if options && options.syntheticClick
              event.send(eventName, el)

  trigger: (eventName, args...) ->
    if eventName of @trackedEvents
      @trackedEvents[eventName].send(eventName, args...)
    else
      err = new Error("SnowplowEventTracker: Unknown event '#{eventName}'")
      # Log error with New Relic if available, otherwise throw the error
      if window.NREUM then window.NREUM.noticeError(err) else throw err

module.exports.SnowplowEventTracker = SnowplowEventTracker
